import { useState } from "react";
import { textes } from "../../constants/textes";
import Abonnements from "../../components/abonnements/abonnements";
import TypeAbonnements from "../../components/abonnements/typeabonnements";



export default function AbonnementsView() {
    // states
    const [page, setPage] = useState(0);

    const displayPages = () => {
        if (page === 0) {
            return <Abonnements />;
        } else {
            return <TypeAbonnements />;
        }
    }

    // affichages
    return (
        <div className="container-fluid">
        <h1 className="h4 mb-4 font-weight-bold text_primary"><i className="fa fa-gift mr-1"></i> {textes.fr.abonnementslabel}</h1>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>{textes.fr.abonnementslabel}</span>
                </button>
                <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>{textes.fr.typeabonnementslabel}</span>
                </button>
            </div>
            {displayPages()}
        </div>
    )

}